import React, { PropsWithChildren } from "react";

import "./AttentionBox.css";
import IconInfo from "./IconInfo";

interface Props {
    title: string;
    text?: string;
    inContainer?: boolean;
}

const AttentionBox: React.FC<Props> = ({ title, text, inContainer, children }: PropsWithChildren<Props>) => {
    const element = (
        <div className="attention_box">
            <div className="attention_box__header">
                <IconInfo className="attention_box__icon" />
                <div className="attention_box__title">{title}</div>
            </div>
            <div className="attention_box__content">
                {text !== undefined ? <p>{text}</p> : null}
                {children}
            </div>
        </div>
    );
    if (inContainer) {
        return (
            <div className="attention_box__container">
                {element}
            </div>
        )
    } else {
        return element;
    }
};

export default AttentionBox;
